export default __webpack_public_path__ + "static/media/1.266378de.png";